<template>
  <div id="service-note">
    <div class="grid-column jc-b center">
      <div class="sac__font-32 f-white semi-bold">
        Notes
      </div>
      <button
        v-if="!closedStatus.includes(serviceItem.serviceStatus)"
        type="button"
        class="sac__button bg-default"
        @click="handleAddNote"
      >
        + Add a note
      </button>
    </div>
    <div v-if="loadingNotes" class="loading-container">
      <img src="@shared/assets/img/general/loading.svg" alt="loading">
    </div>
    <div v-else-if="noteList.length">
      <fragment>
        <div
          v-for="(item, idx) in noteList.slice(0, 2)"
          :key="idx"
          class="note-container"
        >
          <div class="grid-column ai-s jc-b gap-16">
            <div>
              <div class="sac__font-14 f-white med">
                {{ item.userName }} - {{ formatNoteDate(item.noteDate) }} at {{ formatTime(item.noteDate) }}
              </div>
            </div>
            <div class="grid-column ai-c gap-16 show-on-hover">
              <button
                v-if="isEditable(item.userName, item.noteDate)"
                type="button"
                @click="handleNoteView(item, true)"
              >
                <img src="@shared/assets/img/service/yellow-edit.svg" alt="edit" class="img-size-16" />
              </button>
              <button
                v-if="isSmacAdmin"
                type="button"
                @click="deleteNote(item)"
              >
                <img src="@shared/assets/img/service/yellow-delete.svg" alt="delete" class="img-size-16" />
              </button>
            </div>
          </div>
          <div
            class="sac__font-12 f-white margin-top-16"
          >
            {{ formatDesc(item.note) }}
          </div>
          <button
            v-if="item.showSeeMore"
            type="button"
            class="more-btn"
            @click="handleNoteView(item)"
          >
            See more
          </button>
        </div>
        <button
          v-if="noteList.length > 2"
          type="button"
          class="more-btn large"
          @click="toggleActionModal(true, 'view-all-notes')"
        >
          See all member notes ({{ noteList.length }})
        </button>
      </fragment>
    </div>
    <div v-else class="grid-row ai-c jc-c gap-24 margin-top-32">
      <div class="no-notes-image">
        <img
          src="../../../assets/img/service/note.svg"
          alt="no-notes"
          class="img-size-parent"
        />
      </div>
      <div class="sac__font-24 f-white med center">
        No Notes
      </div>
    </div>
  </div>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'ServiceNotes',
  mixins: [serviceMixin],
  props: {
    serviceItem: Object,
  },
  computed: {
    noteList() {
      if (!this.customerNoteList.length) {
        return [];
      }
      return this.customerNoteList.map((item) => {
        const showSeeMore = item.note ? item.note.length > 30 : false;
        return {
          ...item,
          showSeeMore,
        };
      });
    },
  },
  mounted() {
    this.getCustomerNotes();
  },
  methods: {
    async getCustomerNotes() {
      await this.$store.dispatch('getCustomerNotes', this.serviceItem.customerId);
    },
    formatDesc(note) {
      if (note.length > 30) {
        return `${note.substring(0, 30)}... `;
      }
      return `${note}`;
    },
  },
};
</script>
<style lang="scss" scoped>
#service-note {
  min-width: 27rem;
  .note-container {
    background-color: $N90;
    padding: 16px;
    border-radius: 6px;
    margin-top: 16px;
    .show-on-hover {
      opacity: 0;
    }
    &:hover {
      .show-on-hover {
        opacity: 1;
      }
    }
  }
  .more-btn {
    display: grid;
    justify-self: flex-end;
    color: $SUNSET100;
    text-decoration: underline;
    cursor: pointer;
    text-align: right;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.3px;
    &.large {
      padding: 12px 0;
      font-size: 1rem;
    }
  }
  .no-notes-image {
    display: grid;
    height: 200px;
    width: 200px;
    border-radius: 100px;
    background-color: $NAVY100;
  }
}
</style>
